import { createAction, handleActions } from 'redux-actions'

const setSetup = createAction('SCREENS/INSIGHTS/SET_SETUP')
const resetSetup = createAction('SCREENS/INSIGHTS/RESET_SETUP')
//{ label: 'Orders', value: 'Order' }, < taken out for now as it does nothing
const defaultState = {
  models: [
    { label: 'Profit & Loss', value: 'Project' },
    { label: 'Project Phase', value: 'ProjectPhase' },
    { label: 'Estimates', value: 'Estimate' },
    { label: 'Timesheets', value: 'Timesheet' },
  ],
  model: 'Estimate',
  fields: {
    Project: {
      client_id: 'Client',
      client_contact_id: 'Contact',
      contracts_manager_id: 'Contracts Manager',
      supervisor_id: 'Supervisor',
    },
    ProjectPhase: {
      time_frame: 'Time Frame',
      contracts_manager_id: 'Contracts Manager',
    },
    Estimate: {
      client_id: 'Client',
      project_id: 'Project',
      client_contact_id: 'Contact',
      decision_maker_id: 'Decision Maker',
      user_id: 'Owner',
      status_key: 'Status',
    },
    Order: {},
    Timesheet: {
      subcontractor_id: 'Subcontractor',
      project_id: 'Project',
    },
  },
  field: undefined,
}

const reducer = handleActions(
  {
    [setSetup]: (state, action) => ({ ...state, ...action.payload }),
    [resetSetup]: () => defaultState,
  },
  defaultState,
)

export { setSetup, resetSetup, reducer }
